import 'regenerator-runtime/runtime';
import { initializeApp } from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import AppQueryClientProvider from './components/AppQueryClientProvider/AppQueryClientProvider';
import AppSwitcher from './components/AppSwitcher/AppSwitcher';
import AuthenticateBitrise from './components/Authenticate/AuthenticateBitrise';
import AuthenticateFirebase from './components/Authenticate/AuthenticateFirebase';
import AuthenticateLaunchDarkly from './components/Authenticate/AuthenticateLaunchDarkly';
import AuthenticateTrace from './components/Authenticate/AuthenticateTrace';
import Root from './components/Root/Root';
import Tracking from './components/Tracking/Tracking';
import { initLogging, initRum } from './utils/logging';

import './index.css';

// Redirect the user from standalone Trace app to the
// to the /trace route inside the main Bitrise domain.
if (
  window.location.origin === process.env.APM_FRONTEND_URL_STANDALONE &&
  process.env.APM_FRONTEND_URL
) {
  if (process.env.APM_FRONTEND_URL) {
    window.location.replace(process.env.APM_FRONTEND_URL);
  }
}

initLogging();
initRum();

initializeApp({
  apiKey: process.env.FIREBASE_API_KEY_FRONTEND,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_DB_URL,
  projectId: process.env.FIREBASE_PROJECT_ID,
  appId: process.env.FIREBASE_APP_ID_FRONTEND,
});

render(
  <BrowserRouter basename="/trace">
    <Tracking>
      <AuthenticateBitrise>
        <AppQueryClientProvider>
          <Switch>
            <Route component={AppSwitcher} exact path="/" />
            <Route>
              <AuthenticateTrace>
                <AuthenticateFirebase>
                  <AuthenticateLaunchDarkly>
                    <Root />
                  </AuthenticateLaunchDarkly>
                </AuthenticateFirebase>
              </AuthenticateTrace>
            </Route>
          </Switch>
        </AppQueryClientProvider>
      </AuthenticateBitrise>
    </Tracking>
  </BrowserRouter>,
  document.getElementById('Root'),
);
